import React from 'react';
import EcxSurveyTopbar from './editorparts/EcxSurveyTopbar';
import EcxSurveyCanvas from './editorparts/EcxSurveyCanvas';
import EcxSurveyProperties from './editorparts/EcxSurveyProperties';
import EcxSurveyToolbar from './editorparts/EcxSurveyToolbar';
import EcxSurveyViewer from './EcxSurveyViewer';
import { useSurveyStore } from './surveyutilities/surveyStore';
import './EcxSurveyEditor.css';

function EcxSurveyEditor({ onSave, onPublish }) {
    const isPreviewMode = useSurveyStore((state) => state.isPreviewMode);

    return (
        <div className="ecx-survey-editor">
            <EcxSurveyTopbar onSave={onSave} onPublish={onPublish} />
            {isPreviewMode ? (
                <div className="ecx-survey-editor__preview">
                    <EcxSurveyViewer />
                </div>
            ) : (
                <div className="ecx-survey-editor__workspace">
                    <aside className="ecx-survey-editor__panel ecx-survey-editor__toolbar">
                        <EcxSurveyToolbar />
                    </aside>
                    <section className="ecx-survey-editor__panel ecx-survey-editor__canvas">
                        <EcxSurveyCanvas />
                    </section>
                    <aside className="ecx-survey-editor__panel ecx-survey-editor__properties">
                        <EcxSurveyProperties />
                    </aside>
                </div>
            )}
        </div>
    );
}

export default EcxSurveyEditor;
